import React, { Component } from 'react';
import { Select } from 'antd';
import { queryHrList } from '@api/hr/hr';

const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = { data: [] };
  }

  componentDidMount() {
    this.searchUser('');
  }

  submit = () => {
    const data = this.props.form.getFieldsValue();
    data.orgUuid = this.state.orgUuid;
    this.props.form.validateFields(err => {
      if (!err) {
        this.props.handSubmit(data);
      }
    });
  };

  onChange = (value, options) => {
    this.setState({
      value,
    });
    this.props.onChange(value, options);
  };

  searchUser = value => {
    const params = {};
    params.condition = value;
    queryHrList({ ...params, status: 1 }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
        });
      }
    });
  };

  render() {
    const { value, data } = this.state;
    return (
      <Select
        showSearch
        mode={this.props.isMultiple || ''}
        value={value}
        onChange={this.onChange}
        onSearch={this.searchUser}
        placeholder="人员"
        optionFilterProp="children"
        filterOption={(input, option) => {
          return option.props.children.length
            ? option.props.children.filter(child =>
                child.toLowerCase().indexOf(input.toLowerCase()),
              ).length >= 0
            : option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }}
      >
        {value && name && !data.some(item => item.uuid === value) ? (
          <Option key={value} disabled>
            {name}(已禁用)
          </Option>
        ) : null}
        {data.map(item => (
          <Option key={item.uuid}>
            {item.name} {item.workOrgName ? `(${item.workOrgName})` : ''}
          </Option>
        ))}
      </Select>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/comm/SearchHr.js